import type { GInfoPanelLeftColumnProps } from './GInfoPanelLeftColumn';

import { GInfoPanelGroupItem } from './GInfoPanelGroupItem';
import { Box, BlockStack } from '@shopify/polaris';

interface GInfoPanelGroupProps extends Pick<
  GInfoPanelLeftColumnProps,
  'groups' | 'selectedId' | 'selectedBackground' | 'onSelect' | 'onHover' | 'search'
> {
  isSearching?: boolean;
}

export const GInfoPanelGroup = ({
  groups,
  search,
  selectedId,
  selectedBackground,
  onSelect,
  onHover,
  isSearching = false,
}: GInfoPanelGroupProps) => {
  if (groups.length === 0) return null;

  return (
    <Box paddingBlock="200" {...(search ? { paddingBlockStart: '0' } : {})}>
      <BlockStack {...(isSearching ? { gap: '0' } : { gap: '300' })}>
        {groups.map((group, index) => (
          <GInfoPanelGroupItem
            key={group.groupLabel}
            groupId={index}
            hideLabel={isSearching}
            selectedBackground={selectedBackground}
            group={group}
            selectedId={selectedId}
            onSelect={onSelect}
            onHover={onHover}
          />
        ))}
      </BlockStack>
    </Box>
  );
};
